import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../Firebase/Config";
import RouteWithTitle from '../../../Layout/RouteWithTitle';
import Header from "./Header/Header";
import Loading from "../Loading/Loading";

function Services() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    const ref = collection(db, "service");
    getDocs(ref).then((snapshot) => {
      if (snapshot.empty) {
        setError("خطایی رخ داد");
        setLoading(false);
      } else {
        setLoading(false);
        let result = [];
        snapshot.docs.forEach((doc) => {
          result.push({ id: doc.id, ...doc.data() });
        });
        setData(result);
      }
    });
  }, []);

  return (
    <RouteWithTitle>
    <div className="Container">
      <div id="service" className="bg-white" dir="rtl">
        <Header />
        {error ? (
          error
        ) : loading ? (
          <Loading />
        ) : data ? (
          <div className="flex flex-wrap text-white">
            {data
            .sort((a, b) => a.Id - b.Id)
            .map(item => (
              <div className="xl:w-1/2 xl:p-5 py-5 sm:w-full" key={item.Id}>
                <div className="mb-5">
                  <img className="w-16 h-16 aspect-square object-contain" src={item.Picture} alt={item.Title}  />
                </div>
                <div>
                  <h4 className="text-custom_black mb-5">{item.Title}</h4>
                  <p className="font-thin text-custom_pink text-sm text-justify">
                    {item.Description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-black">داده‌ای وجود ندارد</p>
        )}
      </div>
    </div>
    </RouteWithTitle>
  );  
}

export default Services;